import axios from "axios";

export default{
    getFilters() {
        return axios.get("app/filters");
    },
};